import { Namespace, TFuncKey } from 'react-i18next';

export const TIMEZONES = {
  'Africa/Algiers': {
    locationIdentifier: 'timezones.locations.Africa/Algiers',
    timezone: 'Africa/Algiers',
  },
  'Africa/Cairo': {
    locationIdentifier: 'timezones.locations.Africa/Cairo',
    timezone: 'Africa/Cairo',
  },
  'Africa/Casablanca': {
    locationIdentifier: 'timezones.locations.Africa/Casablanca',
    timezone: 'Africa/Casablanca',
  },
  'Africa/Harare': {
    locationIdentifier: 'timezones.locations.Africa/Harare',
    timezone: 'Africa/Harare',
  },
  'Africa/Nairobi': {
    locationIdentifier: 'timezones.locations.Africa/Nairobi',
    timezone: 'Africa/Nairobi',
  },
  'America/Argentina/Buenos_Aires': {
    locationIdentifier: 'timezones.locations.America/Argentina/Buenos_Aires',
    timezone: 'America/Argentina/Buenos_Aires',
  },
  'America/Belize': {
    locationIdentifier: 'timezones.locations.America/Belize',
    timezone: 'America/Belize',
  },
  'America/Bogota': {
    locationIdentifier: 'timezones.locations.America/Bogota',
    timezone: 'America/Bogota',
  },
  'America/Boise': {
    locationIdentifier: 'timezones.locations.America/Boise',
    timezone: 'America/Boise',
  },
  'America/Caracas': {
    locationIdentifier: 'timezones.locations.America/Caracas',
    timezone: 'America/Caracas',
  },
  'America/Chicago': {
    locationIdentifier: 'timezones.locations.America/Chicago',
    timezone: 'America/Chicago',
  },
  'America/Chihuahua': {
    locationIdentifier: 'timezones.locations.America/Chihuahua',
    timezone: 'America/Chihuahua',
  },
  'America/Dawson': {
    locationIdentifier: 'timezones.locations.America/Dawson',
    timezone: 'America/Dawson',
  },
  'America/Detroit': {
    locationIdentifier: 'timezones.locations.America/Detroit',
    timezone: 'America/Detroit',
  },
  'America/Godthab': {
    locationIdentifier: 'timezones.locations.America/Godthab',
    timezone: 'America/Godthab',
  },
  'America/Juneau': {
    locationIdentifier: 'timezones.locations.America/Juneau',
    timezone: 'America/Juneau',
  },
  'America/Los_Angeles': {
    locationIdentifier: 'timezones.locations.America/Los_Angeles',
    timezone: 'America/Los_Angeles',
  },
  'America/Mexico_City': {
    locationIdentifier: 'timezones.locations.America/Mexico_City',
    timezone: 'America/Mexico_City',
  },
  'America/Montevideo': {
    locationIdentifier: 'timezones.locations.America/Montevideo',
    timezone: 'America/Montevideo',
  },
  'America/Phoenix': {
    locationIdentifier: 'timezones.locations.America/Phoenix',
    timezone: 'America/Phoenix',
  },
  'America/Regina': {
    locationIdentifier: 'timezones.locations.America/Regina',
    timezone: 'America/Regina',
  },
  'America/Santiago': {
    locationIdentifier: 'timezones.locations.America/Santiago',
    timezone: 'America/Santiago',
  },
  'America/Sao_Paulo': {
    locationIdentifier: 'timezones.locations.America/Sao_Paulo',
    timezone: 'America/Sao_Paulo',
  },
  'America/St_Johns': {
    locationIdentifier: 'timezones.locations.America/St_Johns',
    timezone: 'America/St_Johns',
  },
  'America/Tijuana': {
    locationIdentifier: 'timezones.locations.America/Tijuana',
    timezone: 'America/Tijuana',
  },
  'Asia/Almaty': {
    locationIdentifier: 'timezones.locations.Asia/Almaty',
    timezone: 'Asia/Almaty',
  },
  'Asia/Baghdad': {
    locationIdentifier: 'timezones.locations.Asia/Baghdad',
    timezone: 'Asia/Baghdad',
  },
  'Asia/Baku': {
    locationIdentifier: 'timezones.locations.Asia/Baku',
    timezone: 'Asia/Baku',
  },
  'Asia/Bangkok': {
    locationIdentifier: 'timezones.locations.Asia/Bangkok',
    timezone: 'Asia/Bangkok',
  },
  'Asia/Colombo': {
    locationIdentifier: 'timezones.locations.Asia/Colombo',
    timezone: 'Asia/Colombo',
  },
  'Asia/Dhaka': {
    locationIdentifier: 'timezones.locations.Asia/Dhaka',
    timezone: 'Asia/Dhaka',
  },
  'Asia/Dubai': {
    locationIdentifier: 'timezones.locations.Asia/Dubai',
    timezone: 'Asia/Dubai',
  },
  'Asia/Irkutsk': {
    locationIdentifier: 'timezones.locations.Asia/Irkutsk',
    timezone: 'Asia/Irkutsk',
  },
  'Asia/Jerusalem': {
    locationIdentifier: 'timezones.locations.Asia/Jerusalem',
    timezone: 'Asia/Jerusalem',
  },
  'Asia/Kabul': {
    locationIdentifier: 'timezones.locations.Asia/Kabul',
    timezone: 'Asia/Kabul',
  },
  'Asia/Kamchatka': {
    locationIdentifier: 'timezones.locations.Asia/Kamchatka',
    timezone: 'Asia/Kamchatka',
  },
  'Asia/Karachi': {
    locationIdentifier: 'timezones.locations.Asia/Karachi',
    timezone: 'Asia/Karachi',
  },
  'Asia/Kathmandu': {
    locationIdentifier: 'timezones.locations.Asia/Kathmandu',
    timezone: 'Asia/Kathmandu',
  },
  'Asia/Kolkata': {
    locationIdentifier: 'timezones.locations.Asia/Kolkata',
    timezone: 'Asia/Kolkata',
  },
  'Asia/Krasnoyarsk': {
    locationIdentifier: 'timezones.locations.Asia/Krasnoyarsk',
    timezone: 'Asia/Krasnoyarsk',
  },
  'Asia/Kuala_Lumpur': {
    locationIdentifier: 'timezones.locations.Asia/Kuala_Lumpur',
    timezone: 'Asia/Kuala_Lumpur',
  },
  'Asia/Kuwait': {
    locationIdentifier: 'timezones.locations.Asia/Kuwait',
    timezone: 'Asia/Kuwait',
  },
  'Asia/Magadan': {
    locationIdentifier: 'timezones.locations.Asia/Magadan',
    timezone: 'Asia/Magadan',
  },
  'Asia/Rangoon': {
    locationIdentifier: 'timezones.locations.Asia/Rangoon',
    timezone: 'Asia/Rangoon',
  },
  'Asia/Seoul': {
    locationIdentifier: 'timezones.locations.Asia/Seoul',
    timezone: 'Asia/Seoul',
  },
  'Asia/Shanghai': {
    locationIdentifier: 'timezones.locations.Asia/Shanghai',
    timezone: 'Asia/Shanghai',
  },
  'Asia/Taipei': {
    locationIdentifier: 'timezones.locations.Asia/Taipei',
    timezone: 'Asia/Taipei',
  },
  'Asia/Tehran': {
    locationIdentifier: 'timezones.locations.Asia/Tehran',
    timezone: 'Asia/Tehran',
  },
  'Asia/Tokyo': {
    locationIdentifier: 'timezones.locations.Asia/Tokyo',
    timezone: 'Asia/Tokyo',
  },
  'Asia/Vladivostok': {
    locationIdentifier: 'timezones.locations.Asia/Vladivostok',
    timezone: 'Asia/Vladivostok',
  },
  'Asia/Yakutsk': {
    locationIdentifier: 'timezones.locations.Asia/Yakutsk',
    timezone: 'Asia/Yakutsk',
  },
  'Asia/Yekaterinburg': {
    locationIdentifier: 'timezones.locations.Asia/Yekaterinburg',
    timezone: 'Asia/Yekaterinburg',
  },
  'Atlantic/Azores': {
    locationIdentifier: 'timezones.locations.Atlantic/Azores',
    timezone: 'Atlantic/Azores',
  },
  'Atlantic/Canary': {
    locationIdentifier: 'timezones.locations.Atlantic/Canary',
    timezone: 'Atlantic/Canary',
  },
  'Atlantic/Cape_Verde': {
    locationIdentifier: 'timezones.locations.Atlantic/Cape_Verde',
    timezone: 'Atlantic/Cape_Verde',
  },
  'Australia/Adelaide': {
    locationIdentifier: 'timezones.locations.Australia/Adelaide',
    timezone: 'Australia/Adelaide',
  },
  'Australia/Brisbane': {
    locationIdentifier: 'timezones.locations.Australia/Brisbane',
    timezone: 'Australia/Brisbane',
  },
  'Australia/Darwin': {
    locationIdentifier: 'timezones.locations.Australia/Darwin',
    timezone: 'Australia/Darwin',
  },
  'Australia/Hobart': {
    locationIdentifier: 'timezones.locations.Australia/Hobart',
    timezone: 'Australia/Hobart',
  },
  'Australia/Perth': {
    locationIdentifier: 'timezones.locations.Australia/Perth',
    timezone: 'Australia/Perth',
  },
  'Australia/Sydney': {
    locationIdentifier: 'timezones.locations.Australia/Sydney',
    timezone: 'Australia/Sydney',
  },
  'Europe/Amsterdam': {
    locationIdentifier: 'timezones.locations.Europe/Amsterdam',
    timezone: 'Europe/Amsterdam',
  },
  'Europe/Athens': {
    locationIdentifier: 'timezones.locations.Europe/Athens',
    timezone: 'Europe/Athens',
  },
  'Europe/Belgrade': {
    locationIdentifier: 'timezones.locations.Europe/Belgrade',
    timezone: 'Europe/Belgrade',
  },
  'Europe/Brussels': {
    locationIdentifier: 'timezones.locations.Europe/Brussels',
    timezone: 'Europe/Brussels',
  },
  'Europe/Bucharest': {
    locationIdentifier: 'timezones.locations.Europe/Bucharest',
    timezone: 'Europe/Bucharest',
  },
  'Europe/Dublin': {
    locationIdentifier: 'timezones.locations.Europe/Dublin',
    timezone: 'Europe/Dublin',
  },
  'Europe/Helsinki': {
    locationIdentifier: 'timezones.locations.Europe/Helsinki',
    timezone: 'Europe/Helsinki',
  },
  'Europe/Lisbon': {
    locationIdentifier: 'timezones.locations.Europe/Lisbon',
    timezone: 'Europe/Lisbon',
  },
  'Europe/London': {
    locationIdentifier: 'timezones.locations.Europe/London',
    timezone: 'Europe/London',
  },
  'Europe/Moscow': {
    locationIdentifier: 'timezones.locations.Europe/Moscow',
    timezone: 'Europe/Moscow',
  },
  'Europe/Sarajevo': {
    locationIdentifier: 'timezones.locations.Europe/Sarajevo',
    timezone: 'Europe/Sarajevo',
  },
  GMT: {
    locationIdentifier: 'timezones.locations.GMT',
    timezone: 'GMT',
  },
  'Pacific/Auckland': {
    locationIdentifier: 'timezones.locations.Pacific/Auckland',
    timezone: 'Pacific/Auckland',
  },
  'Pacific/Fiji': {
    locationIdentifier: 'timezones.locations.Pacific/Fiji',
    timezone: 'Pacific/Fiji',
  },
  'Pacific/Guam': {
    locationIdentifier: 'timezones.locations.Pacific/Guam',
    timezone: 'Pacific/Guam',
  },
  'Pacific/Honolulu': {
    locationIdentifier: 'timezones.locations.Pacific/Honolulu',
    timezone: 'Pacific/Honolulu',
  },
  'Pacific/Midway': {
    locationIdentifier: 'timezones.locations.Pacific/Midway',
    timezone: 'Pacific/Midway',
  },
  'Pacific/Tongatapu': {
    locationIdentifier: 'timezones.locations.Pacific/Tongatapu',
    timezone: 'Pacific/Tongatapu',
  },
} as const satisfies Record<
  string,
  {
    locationIdentifier: TFuncKey<Namespace<'en'>>;
    timezone: string;
  }
>;
